import {NotificationRowModel} from "app/modules/notifications/model/notification.model";
import axios from "axios";
import {showToast} from "app/shared/util/toast.util";
import {toast} from "react-toastify";
import error = toast.error;

export const fetchNotificationsOverview = async ({signal, pagination}): Promise<NotificationRowModel[]> => {
  return await new Promise((resolve, reject) => {
    axios.get(`/api/notifications?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`, {signal})
      .then(res => resolve(res.data))
      .catch(err => {
        showToast(error, err.response.data.detail);
      });
  });
};
